<div class="layout-column full-height" appBringozIdGenerator="threepl-provider-extra-data">
  @if (extraData()) {
  @switch (providerType()) {
  @case (providers.Contractor) {
    <div class="layout-column">
    @if (extraData().driverId) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Agent ID' | translate }}</span>:
        <span class="margin-left-5">{{ extraData().driverId }}</span>
      </div>
    }
    @if (extraData().mainVehiclePlateNumber) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Vehicle plate number' | translate }}</span>:
        <span class="margin-left-5">{{ extraData().mainVehiclePlateNumber }}</span>
      </div>
    }
    @if (extraData().trailerVehiclePlateNumberList) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Trailer vehicle plate number' | translate }}</span>:
        <app-threepl-service-chips class="margin-left-5" [items]="extraData().trailerVehiclePlateNumberList" [maxItems]="2"></app-threepl-service-chips>
      </div>
    }
    @if (extraData().pickupApprovalInfo?.contractorApprovalStatus) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Pick-up approval status' | translate }}</span>:
        <span class="margin-left-5">{{ extraData().pickupApprovalInfo.contractorApprovalStatus }}</span>
      </div>
    }
    @if (extraData().destinationApprovalInfo?.contractorApprovalStatus) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Destination approval status' | translate }}</span>:
        <span class="margin-left-5">{{ extraData().destinationApprovalInfo.contractorApprovalStatus }}</span>
      </div>
    }
    </div>
  }
  @case (providers.TrainIL) {
    <div>
    <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Voucher ID' | translate }}</span>:
        <span class="margin-left-5">{{ extraData().voucherId }}</span>
      </div>
    <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Name' | translate }}</span>:
        <span class="margin-left-5">{{ extraData().name }}</span>
      </div>
    <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Approval status' | translate }}</span>:
        <span class="margin-left-5">{{ extraData().approvalStatus }}</span>
      </div>
    <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Pick-up depot' | translate }}</span>:
        <!-- ui-fallback: depot link stays an admin component. Guarded: unlike the AngularJS one it throws on a missing depot. -->
        @if (extraData().pickupDepot; as depot) { <app-depot-link class="margin-left-5" [depot]="depot"></app-depot-link> }
      </div>
    <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Drop-off depot' | translate }}</span>:
        @if (extraData().destinationDepot; as depot) { <app-depot-link class="margin-left-5" [depot]="depot"></app-depot-link> }
      </div>
    </div>
  }
  @case (providers.Uber) {
    <div class="layout-row">
      <div class="flex layout-column">
    @if (extraData().quoteId) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Quote ID' | translate }}</span>:
        <span class="margin-left-5">{{ extraData().quoteId }}</span>
      </div>
    }
    @if (extraData().deliveryId) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Delivery ID' | translate }}</span>:
        <span class="margin-left-5">{{ extraData().deliveryId }}</span>
      </div>
    }
    @if (extraData().uuid) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'UUID' | translate }}</span>:
        <span class="margin-left-5">{{ extraData().uuid }}</span>
      </div>
    }
    @if (extraData().supportId) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Support ID' | translate }}</span>:
        <span class="margin-left-5">{{ extraData().supportId }}</span>
      </div>
    }
    @if (extraData().vehicleType) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Vehicle Type' | translate }}</span>:
        <span class="margin-left-5">{{ extraData().vehicleType }}</span>
      </div>
    }
    @if (extraData().driverName) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Driver' | translate }}</span>:
        <span class="margin-left-5">{{ extraData().driverName }}</span>
      </div>
    }
    @if (extraData().driverPhoneNumber) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Driver Phone Number' | translate }}</span>:
        <span class="margin-left-5">{{ extraData().driverPhoneNumber | bringozPhone }}</span>
      </div>
    }
    @if (extraData().complete) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Complete' | translate }}</span>:
        <span class="margin-left-5">{{ extraData().complete | translate }}</span>
      </div>
    }
    @if (extraData().currency) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Currency' | translate }}</span>:
        <span class="margin-left-5">{{ extraData().currency }}</span>
      </div>
    }
    @if (extraData().courierImminent) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Courier Imminent' | translate }}</span>:
        <span class="margin-left-5">{{ extraData().courierImminent }}</span>
      </div>
    }
    @if (extraData().dropoffIdentifier) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Drop-off Identifier' | translate }}</span>:
        <span class="margin-left-5">{{ extraData().dropoffIdentifier }}</span>
      </div>
    }
    @if (extraData().tip) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Tip' | translate }}</span>:
        <span class="margin-left-5">{{ extraData().tip | bringozPrice }}</span>
      </div>
    }
      </div>
      <div class="flex layout-column">
    @if (extraData().pickupEta) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Pick-up Eta' | translate }}</span>:
        <span class="margin-left-5">{{ extraData() | bringozFullDate: 'pickupEta' }} {{ extraData() | bringozTime: 'pickupEta' }}</span>
      </div>
    }
    @if (extraData().pickupReady) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Pick-up Ready' | translate }}</span>:
        <span class="margin-left-5">{{ extraData() | bringozFullDate: 'pickupReady' }} {{ extraData() | bringozTime: 'pickupReady' }}</span>
      </div>
    }
    @if (extraData().pickupDeadline) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Pick-up Deadline' | translate }}</span>:
        <span class="margin-left-5">{{ extraData() | bringozFullDate: 'pickupDeadline' }} {{ extraData() | bringozTime: 'pickupDeadline' }}</span>
      </div>
    }
    @if (extraData().dropoffEta) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Drop-off Eta' | translate }}</span>:
        <span class="margin-left-5">{{ extraData() | bringozFullDate: 'dropoffEta' }} {{ extraData() | bringozTime: 'dropoffEta' }}</span>
      </div>
    }
    @if (extraData().dropoffReady) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Drop-off Ready' | translate }}</span>:
        <span class="margin-left-5">{{ extraData() | bringozFullDate: 'dropoffReady' }} {{ extraData() | bringozTime: 'dropoffReady' }}</span>
      </div>
    }
    @if (extraData().dropoffDeadline) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Drop-off Deadline' | translate }}</span>:
        <span class="margin-left-5">{{ extraData() | bringozFullDate: 'dropoffDeadline' }} {{ extraData() | bringozTime: 'dropoffDeadline' }}</span>
      </div>
    }
    @if (extraData().undeliverableAction) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Undeliverable Action' | translate }}</span>:
        <span class="margin-left-5">{{ extraData().undeliverableAction }}</span>
      </div>
    }
    @if (extraData().undeliverableReason) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Undeliverable Reason' | translate }}</span>:
        <span class="margin-left-5">{{ extraData().undeliverableReason }}</span>
      </div>
    }
      </div>
    </div>
  }
  @case (providers.Wolt) {
    <div class="layout-row">
      <div class="flex layout-column">
    @if (extraData().dispatchedId) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'ID' | translate }}</span>:
        <span class="margin-left-5">{{ extraData().dispatchedId }}</span>
      </div>
    }
    @if (extraData().quoteId) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Quote ID' | translate }}</span>:
        <span class="margin-left-5">{{ extraData().quoteId }}</span>
      </div>
    }
    @if (extraData().courierId) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Courier ID' | translate }}</span>:
        <span class="margin-left-5">{{ extraData().courierId }}</span>
      </div>
    }
    @if (extraData().dropoffMin) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Earliest Dropoff Time Estimate' | translate }}</span>:
        <span class="margin-left-5">{{ extraData() | bringozDate: 'dropoffMin' }} {{ extraData() | bringozTime: 'dropoffMin' }}</span>
      </div>
    }
    @if (extraData().minPrepTime) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Minimum Preparation Time' | translate }}</span>:
        <span class="margin-left-5">{{ extraData().minPrepTime }} {{ 'Minutes' | translate }}</span>
      </div>
    }
    @if (extraData().completedAt) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'Completed At' | translate }}</span>:
        <span class="margin-left-5">{{ extraData() | bringozDate: 'completedAt' }} {{ extraData() | bringozTime: 'completedAt' }}</span>
      </div>
    }
    @if (extraData().onDemand !== undefined) {
      <div class="layout-row layout-align-start-center margin-bottom-5 br-body-2">
        <span>{{ 'On Demand' | translate }}</span>:
        <span class="margin-left-5">{{ (extraData().onDemand ? 'Yes' : 'No') | translate }}</span>
      </div>
    }
      </div>
    </div>
  }
  }
  }
</div>
